// Sends a file to S3 with the presigned POST from createFormAssetUpload /
// createFormFileUpload (plan §4.2): every ticket field first, the file last.
// S3 answers 204; any non-2xx (or a network failure) is a failed upload.

export const UPLOAD_FAILED = 'Upload failed. Try again.';

export const uploadToTicket = async (ticket, file) => {
  try {
    const body = new FormData();
    const fields = (ticket && ticket.fields) || {};
    Object.keys(fields).forEach((key) => body.append(key, fields[key]));
    body.append('file', file);
    const res = await fetch(ticket.url, { method: 'POST', body });
    if (res && res.ok) return { ok: true };
    return { ok: false, message: UPLOAD_FAILED };
  } catch (e) {
    return { ok: false, message: UPLOAD_FAILED };
  }
};
